import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import type SessionService from 'garaje/services/session';

interface AccountMenuSignature {
  Element: HTMLDivElement;
}

// Stands in for the side nav's account actions, which the shell hides below `lg`.
export default class AccountMenu extends Component<AccountMenuSignature> {
  @service declare session: SessionService;

  logOut = (): void => {
    void this.session.invalidate();
  };

  <template>
    <div ...attributes>
      <BasicDropdown as |dropdown|>
        <dropdown.Trigger>
          <button
            type="button"
            class="flex h-7 w-7 items-center justify-center rounded-lg text-carbon-40 ring-1 ring-inset ring-carbon-20 transition-colors hover:bg-gem-5"
            aria-label="Account actions"
            data-test-account-menu-trigger
          >
            {{svgJar "horizontal-dots" width="18" height="4" class="block shrink-0"}}
          </button>
        </dropdown.Trigger>
        <dropdown.Content>
          <div class="min-w-[160px] rounded-2xl bg-white p-1 shadow-md">
            <button
              type="button"
              class="flex w-full items-center gap-2 rounded-lg px-2 py-2 text-base text-carbon-70 transition-colors hover:bg-carbon-5"
              data-test-account-menu-logout
              {{on "click" this.logOut}}
            >
              Log out
            </button>
          </div>
        </dropdown.Content>
      </BasicDropdown>
    </div>
  </template>
}
